import { useDocumentTitle } from '@hooks/index';
import { Translations } from '@translations/translationsTypes';
import { useTranslate } from '@translations/useTranslate';
import { DocumentCards } from '@ui/components/organisms/KnowledgeCenter';
import React, { FC, useEffect } from 'react';
import { RouteComponentProps, useHistory } from 'react-router-dom';

interface IBSRequestParams {
  languageId: string;
}

interface KnowledgeCenterProps extends RouteComponentProps<IBSRequestParams> {
  param: string;
}
export const KnowledgeCenter: FC<KnowledgeCenterProps> = (props) => {
  const { t, setLanguage } = useTranslate();
  useDocumentTitle(t('page.title.knowledge'));
  const history = useHistory();
  useEffect(() => {
    if (props?.match?.params?.languageId) {
      const language =
        props?.match?.params?.languageId === Translations.ar ? Translations.ar : Translations.en;
      setLanguage(language);
      history.replace('/knowledge-center');
    }
  }, [history, props?.match?.params?.languageId, setLanguage]);
  return (
    <>
      <DocumentCards />
    </>
  );
};
